<template>
  <div class="perimeter-company-container">
    <div class="row header" v-if="perimeterAll.length">
      <div>周边公司</div>
      <div class="row perimeter-companies-to-graph">
        <img src="../../assets/img/arrow-right-up.svg" class="icon">
        <div class="perimeter-companies-to-graph-word" @click="toGraphCompanyPage">完整图谱</div>
      </div>
    </div>
    <div class="row perimeter-companies-tab" v-if="perimeterAll.length">
      <div
        class="tab-item" 
        :class="{'tab-item-active': item === perimeterCompanySelectedOptionTab}" 
        v-for="(item, index) in perimeterCompanyTabs" 
        :key="index"
        @click="onPerimeterCompanyTabChange(item)"
        >
        {{item}}
      </div>
    </div>
    <div class="perimeter-content" v-if="perimeterAll.length">
      <div v-if="perimeterCompanySelectedOptionTab === '全部'">
        <div v-for="(item, index) in perimeterAll" :key="index">
          <div class="perimeter-name">{{item.relation}}</div>
          <div v-for="(i, idx) in item.related_companies" :key="idx">
            <div class="perimeter-company-name" @click="toCompanyDetail(i.name)">{{i.stock_code}}</div>
          </div>
        </div>
      </div>
      <div v-if="perimeterCompanySelectedOptionTab !== '全部'">
        <div v-for="(item, index) in perimeter" :key="index">
          <div class="perimeter-company-name" @click="toCompanyDetail(item.name)">{{item.stock_code}}</div>
        </div>
      </div>
    </div>
    <img v-if="!perimeterAll.length" class="perimeter-company-no-data-img" src="../../assets/img/perimeter-company-no-data.svg" alt /> 
    <div v-if="!perimeterAll.length" class="perimeter-company-no-data">暂时没有<span class="company-name">{{searchText}}</span>的周边公司数据,正在持续补充中...</div>     
  </div>
</template>

<script>
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      perimeterCompanySelectedOptionTab: '全部',
      perimeterCompanyTabs: ['全部'],
      perimeterAll: [],
      perimeter: []
    };
  },
  props: {
    searchText: {
      type: String,
      default: ''
    },
    stockCode: {
      type: String
    }
  },
  methods: {
    onPerimeterCompanyTabChange(res) {
      this.perimeterCompanySelectedOptionTab = res;
      if (this.perimeterCompanySelectedOptionTab !== '全部') {
        this.perimeter = this.perimeterAll.filter(item => item.relation === this.perimeterCompanySelectedOptionTab);
        this.perimeter = this.perimeter[0].related_companies;
      }
    },
    toGraphCompanyPage() {
      const routeUrl = this.$router.resolve({
        path: '/graph',
        query: {
          id: this.searchText,
          label: this.stockCode
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    toCompanyDetail(res) {
      if (this.$route.path === '/result' && this.$route.query.type === 'perimeter') {
        this.$router.push({
          name: 'result-page',
          query: {
            type: 'perimeter',
            q: res
          }
        });
      } else {
        this.$router.push({
          name: 'result-page',
          query: {
            q: res
          }
        });
      }
      // this.$router.push({
      //   name: 'result-page',
      //   query: {
      //     q: res
      //   }
      // });
    },
    getPerimeter(searchText) {
      questionQuery.getPerimeter(searchText).then(res => {
        this.perimeterAll = res.result;
        let relationTitle = [];
        relationTitle = this.perimeterAll.map(item => item.relation);
        this.perimeterCompanyTabs = this.perimeterCompanyTabs.concat(relationTitle);
      });
    }
  },
  watch: {
    searchText(val) {
      this.perimeterCompanySelectedOptionTab = '全部';
      this.perimeterCompanyTabs = ['全部'];
      this.perimeterAll = [];
      this.perimeter = [];
      this.getPerimeter(val);
    }
  },
  mounted() {
    this.getPerimeter(this.searchText);
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.perimeter-company-container {
  position: relative;
  height: 447px;
  width: 100%;
  background-color: #ffffff;
  .perimeter-company-no-data-img {
    position: absolute;
    left: 50%;
    top: 100px;
    transform: translateX(-50%);
  }
  .perimeter-company-no-data {
    position: absolute;
    left: 50%;
    top: 245px;
    transform: translateX(-50%);
    color: #9ea1b4;
    font-size: 14px;
    .company-name {
      color: #45a8cc;
    }
  }
  .header {
    justify-content: space-between;
    padding: 13px 24px;
    border-bottom: 1px solid rgba(247, 247, 250, 1);
    font-size: 14px;
    color: #171f46;
    .perimeter-companies-to-graph {
      cursor: pointer;
      .perimeter-companies-to-graph-word {
        margin-left: 4px;
        color: #45a8cc;
        font-size: 14px;
      }
    }
  }
  .perimeter-companies-tab {
    overflow: auto;
    height: 28px;
    line-height: 28px;
    padding: 0 24px;
    border: 1px solid #f7f7fa;
    color: #9ea1b4;
    font-size: 12px;
    .tab-item {
      margin-right: 10px;
      flex-shrink: 0;
      cursor: pointer;
    }
    .tab-item-active {
      color: #45a8cc;
    }
  }
  .perimeter-content {
    padding: 12px 16px;
    height: 360px;
    overflow: auto;
    .perimeter-name {
      padding-left: 8px;
      margin-top: 10px;
      height: 28px;
      line-height: 28px;
      color: rgba(69, 168, 204, 1);
      font-size: 12px;
    }
    .perimeter-company-name {
      padding: 5px 8px;
      color: #464d6c;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background: rgba(247, 248, 252, 1);
        font-weight: 500;
      }
    }
    .perimeter-company-name {
      padding: 5px 8px;
      color: #464d6c;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background: rgba(247, 248, 252, 1);
        font-weight: 500;
      }
    }
  }
}
</style>
